import { render } from "./Home.index.vue?vue&type=template&id=f08aa39c&ts=true"
import script from "./Home.index.vue?vue&type=script&lang=ts"
export * from "./Home.index.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__